import { Exclude, Expose } from "class-transformer";

@Exclude()
export class UpdateCartDto {
    @Expose()
    readonly user_id: number;
}
